<div class="mainWraps">
    <div class="bgImageWrap">
        <img src="../../../assets/images/patch/clientBg.png">
    </div>

    <div class="bgMobileImageWrap">
        <img src="../../../assets/images/ourClientMobileBg.png">
    </div>

    <div class="overLay">
        <div class="textWraps">
            <div class="titleWraps">
                Clientele
            </div>
            <div class="subTitleWrap">
                We have an enviable list of happy customers
            </div>
            <div class="knowMoreWrap">
               <!--  <div class="buttonWrap">
                    <button>
                        KNOW MORE
                    </button>
                </div> -->
            </div>
        </div>
    </div>
</div>


<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
        <!--     <div class="titleWrap">
                Service We Provide
            </div> -->
            <div class="descWrap">
                “Customer service is everything and anything that touches a customer – directly or indirectly. Customer service means servicing customers, and it’s so much more than just solving problems or addressing complaints.”
            </div>
        </div>
        <div class="bodySection">
            <div class="rowWrap" *ngFor = "let i of services">
                <img src="{{i.iconUrl}}">
              <!--    <div class="card">
                    <div class="imageWrap">
                       
                    </div>
                   <div class="textWrap">
                        <div class="titleRowWrap">
                           {{i.title}}
                        </div>
                        <div class="descRowWrap">
                           {{i.desc}}
                        </div>
                    </div> 
                </div>-->
            </div>
        </div>
    </div>
</div>